const DEFAULT_DISPLAY_SETTINGS = {
  container_style: {
    border_color: "#8614dd",
    border_radius: 8,
    border_width: 1,
    background_color: "#ffffff"
  },
  text_display: {
    header_title: "Free Gift",
    remain_title: "Buy {{remain}} more to receive the item(s) below for free:",
    achieve_title: "Congratulations! You’ve received a free gift!",
    claim_button: "Claim",
    claimed_button: "Claimed",
    gift_icon_text: "Please claim your gift",
    gift_icon_text_claimed: "Congratulations! You’ve earned a gift.",
    optional_message: "Select {{gift_number}} from the list below:",
    optional_message_auto_add: "You’ll receive {{gift_number}} gifts",
    choose_gift_message: "You can choose {{gift_remain}} more gifts.",
    choose_enough_gift_message: "You’ve selected the required number of gifts.",
    upsell_message_qty: "Buy {{product}}(x{{remain}}) to get a free gift.",
    upsell_message_amount: "Subtotal of {{product}} need reach to {{remain}} to get a free gift",
    free_text_content: "Free",
    error_message: "An error occurred. You cannot claim it now; please try again later.",
    claim_all_gift_message: "You’ve claimed all the gifts.",
    warning_message: "Please select the required number of gifts."
  },
  header_style: {
    color: "#ffffff",
    background_color: "#000000",
    padding: 10,
    block_color: "#000000"
  },
  embed_btn_style: {
    color: "#ffffff",
    padding: 0,
    background_color: "#8614dd",
    font_size: 14,
    font_weight: 700
  },
  gift_item_style: {
    free_label_and_checkbox_color: "#8614dd",
    color: "#000000",
    helptext_color: "#bdbdbd"
  },
  gift_icon_style: {
    is_icon_displayed: true,
    color: "#000000",
    icon_color: "#8614dd",
    background_color: "#ffffff",
    border_color: "#ffffff",
    border_width: 0,
    border_radius: 35,
    free_gift_image: null
  },
  position_of_popup: "bottom-right",
  cart_btn_selector: ""
};
class tlFreeGift {
  APPLY_TO_PRODUCT = {
    ALL: "all",
    COLLECTION: "collection",
    PRODUCT: "product",
    VARIANT: "variant"
  };
  APPLY_CONDITION_TYPE = {
    AMOUNT: "amount",
    QUANTITY: "quantity"
  };
  AUTO_ADD_TYPE = {
    FIRST_AVAILABLE: "first_available",
    SELECT_TO_ADD: "select_to_add"
  };
  GIFT_TYPE = {
    VARIANT: "variant",
    SAME_BUY: "same_buy"
  };
  ADDED_GIFT_LOCALSTORAGE_KEY = "salepify_fg_basic_added_gift";
  constructor(variantMapCollections, template, rulesApplyOnAll, rulesApplyOnCollection, rulesApplyOnProduct, collectionsOfProduct, displaySetting) {
    this.freeGiftBox = document.querySelector(".salepify-free-gift-box");
    this.freeGiftBoxIcon = document.querySelector(".salepify-free-gift-box-icon");
    this.freeGiftBadge = document.querySelector(".salepify-free-gift-badge");
    this.freeGiftBoxText = document.querySelector(".salepify-free-gift-box-text");
    this.freeGiftModal = document.querySelector(".salepify-free-gift-modal-wrapper");
    this.headerDescription = document.querySelector(".salepify-free-gift-modal__header-description");
    this.freeGiftList = document.getElementById("salepify-free-gift-container__list-gifts");
    this.totalGift = document.querySelector(".salepify-free-gift-total-gift");
    this.giftDescription = document.getElementById("salepify-free-gift-container__description");
    this.claimButton = document.querySelector("#salepify-free-gift-container__claim-btn");
    this.errorBlock = document.getElementById("salepify-free-gift-error");
    this.variantMapCollections = variantMapCollections;
    this.template = template;
    this.rulesApplyOnAll = rulesApplyOnAll;
    this.rulesApplyOnCollection = rulesApplyOnCollection;
    this.collectionsOfProduct = collectionsOfProduct;
    this.rulesApplyOnProduct = rulesApplyOnProduct;
    this.errorSetTimout = null;
    this.residualGift = 0;
    this.isClaimed = false;
    this.claimedCount = 0;
    this.canClaimCount = 0;
    this.giftNumber = 0;
    this.giftSelected = /* @__PURE__ */ new Map();
    this.isShowedFirework = false;
    this.remain = 0;
    this.isConditionMet = false;
    this.currency = tlFreeGiftCurrencySymbol;
    this.currencyRate = 1;
    if (Shopify && Shopify.currency) {
      this.currency = Shopify.currency.active;
      this.currencyRate = Number(Shopify.currency.rate);
    }
    this.displaySetting = displaySetting && displaySetting.free_gift ? {
      container_style: {
        ...DEFAULT_DISPLAY_SETTINGS.container_style,
        ...displaySetting.free_gift.container_style
      },
      text_display: {
        ...DEFAULT_DISPLAY_SETTINGS.text_display,
        ...displaySetting.free_gift.text_display
      },
      header_style: {
        ...DEFAULT_DISPLAY_SETTINGS.header_style,
        ...displaySetting.free_gift.header_style
      },
      embed_btn_style: {
        ...DEFAULT_DISPLAY_SETTINGS.embed_btn_style,
        ...displaySetting.free_gift.embed_btn_style
      },
      gift_item_style: {
        ...DEFAULT_DISPLAY_SETTINGS.gift_item_style,
        ...displaySetting.free_gift.gift_item_style
      },
      gift_icon_style: {
        ...DEFAULT_DISPLAY_SETTINGS.gift_icon_style,
        ...displaySetting.free_gift.gift_icon_style
      },
      position_of_popup: displaySetting.free_gift.position_of_popup || DEFAULT_DISPLAY_SETTINGS.position_of_popup,
      cart_btn_selector: displaySetting.free_gift.cart_btn_selector || DEFAULT_DISPLAY_SETTINGS.cart_btn_selector
    } : DEFAULT_DISPLAY_SETTINGS;
    this.displayRule = this.filterRule();
    if (this.displayRule && this.template === "product") {
      if (this.displayRule.maximum_per_order === void 0) {
        this.displayRule.maximum_per_order = 1;
      }
      this.applyStyle();
      this.renderGifts().then(async () => {
        await this.getRemainAmountToGetFreeGift();
        if (this.displayRule.show_free_gift_widget) {
          this.renderGiftBox();
        }
        this.openCartDrawAfterReload();
        tlFreeGiftOverride();
      });
    }
  }
  applyStyle() {
    const containerStyle = this.displaySetting.container_style;
    const headerStyle = this.displaySetting.header_style;
    const claimBtnStyle = this.displaySetting.embed_btn_style;
    const giftItemStyle = this.displaySetting.gift_item_style;
    const giftiConStyle = this.displaySetting.gift_icon_style;
    const giftIconPosition = this.displaySetting.position_of_popup || "bottom-right";
    document.documentElement.style.setProperty("--tl-free-gift__modal__border-color", containerStyle.border_color);
    document.documentElement.style.setProperty("--tl-free-gift__modal__border-radius", `${containerStyle.border_radius}px`);
    document.documentElement.style.setProperty("--tl-free-gift__modal__border-width", `${containerStyle.border_width}px`);
    document.documentElement.style.setProperty("--tl-free-gift__modal__background-color", containerStyle.background_color);
    document.documentElement.style.setProperty("--tl-free-gift__header__color", headerStyle.color);
    document.documentElement.style.setProperty("--tl-free-gift__header__background-color", headerStyle.background_color);
    document.documentElement.style.setProperty("--tl-free-gift__header__padding", `${headerStyle.padding}px`);
    document.documentElement.style.setProperty("--tl-free-gift__claim-button__padding", `${claimBtnStyle.padding}px`);
    document.documentElement.style.setProperty("--tl-free-gift__claim-button__background-color", claimBtnStyle.background_color);
    document.documentElement.style.setProperty("--tl-free-gift__claim-button__font-size", `${claimBtnStyle.font_size}px`);
    document.documentElement.style.setProperty("--tl-free-gift__claim-button__font-weight", claimBtnStyle.font_weight);
    document.documentElement.style.setProperty("--tl-free-gift__claim-button__color", claimBtnStyle.color);
    document.documentElement.style.setProperty("--tl-free-gift__gift-item-free-label-checkbox__color", giftItemStyle.free_label_and_checkbox_color);
    document.documentElement.style.setProperty("--tl-free-gift__gift-item__color", giftItemStyle.color);
    document.documentElement.style.setProperty("--tl-free-gift__gift-item-helptext__color", giftItemStyle.helptext_color);
    document.documentElement.style.setProperty("--tl-free-gift__gift-icon__color", giftiConStyle.color);
    document.documentElement.style.setProperty("--tl-free-gift__gift-icon__icon-color", giftiConStyle.icon_color);
    document.documentElement.style.setProperty("--tl-free-gift__gift-icon__background-color", giftiConStyle.background_color);
    document.documentElement.style.setProperty("--tl-free-gift__gift-icon__border-color", giftiConStyle.border_color);
    document.documentElement.style.setProperty("--tl-free-gift__gift-icon__border-width", `${giftiConStyle.border_width}px`);
    document.documentElement.style.setProperty("--tl-free-gift__gift-icon__border-radius", `${giftiConStyle.border_radius}px`);
    document.querySelector(".salepify-free-gift-modal__header-title").innerHTML = this.replaceVariables(this.displaySetting.text_display.header_title);
    switch (giftIconPosition) {
      case "bottom-right":
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__bottom", "10px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__right", "10px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__transform", "unset");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__right", "70px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__left", "-150px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__width", "unset");
        break;
      case "bottom-left":
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__bottom", "10px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__right", "100%");
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__transform", "translateX(calc(100% + 10px))");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__right", "");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__left", "80px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__width", "120px");
        break;
      case "center-right":
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__bottom", "50%");
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__right", "10px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__transform", "translateY(50%)");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__right", "70px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__left", "-150px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__width", "unset");
        break;
      case "center-left":
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__bottom", "50%");
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__right", "100%");
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__transform", "translate(calc(100% + 10px), 50%)");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__right", "");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__left", "80px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__width", "120px");
        break;
      default:
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__bottom", "10px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__right", "10px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-position__transform", "unset");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__right", "70px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__left", "-150px");
        document.documentElement.style.setProperty("--tl-free-gift__popup-text__width", "unset");
        break;
    }
  }
  replaceVariables(originalString) {
    originalString = originalString.split("{{name}}").join(this.displayRule.title);
    originalString = originalString.split("{{remain}}").join(this.displayRule.apply_condition_type == this.APPLY_CONDITION_TYPE.AMOUNT ? this.formatMoney(this.remain * this.currencyRate) : this.remain);
    originalString = originalString.split("{{gift_number}}").join(`<strong>${this.giftNumber}</strong>`);
    return originalString;
  }
  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  formatMoney = function(t, e = `{{amount_with_period_and_space_separator}} ${this.currency}`) {
    function n(t2, e2) {
      return void 0 === t2 ? e2 : t2;
    }
    function o(t2, e2, o2, i2) {
      if (e2 = n(e2, 2), o2 = n(o2, ","), i2 = n(i2, "."), isNaN(t2) || null == t2)
        return 0;
      var r2 = (t2 = (t2 / 100).toFixed(e2)).split(".");
      return r2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o2) + (r2[1] ? i2 + r2[1] : "");
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var i = "", r = /\{\{\s*(\w+)\s*\}\}/, a = e || this.money_format;
    switch (a.match(r)[1]) {
      case "amount":
        i = o(t, 2);
        break;
      case "amount_no_decimals":
        i = o(t, 0);
        break;
      case "amount_with_comma_separator":
        i = o(t, 2, ".", ",");
        break;
      case "amount_with_space_separator":
        i = o(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        i = o(t, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        i = o(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        i = o(t, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        i = o(t, 2, "'", ".");
    }
    return a.replace(r, i);
  };
  filterRule() {
    if (this.template !== "product")
      return;
    let rulesApplyOnProductIds = this.rulesApplyOnProduct ? Object.values(this.rulesApplyOnProduct) : [];
    let rulesApplyOnAllIds = this.rulesApplyOnAll ? Object.values(this.rulesApplyOnAll) : [];
    let rulesApplyOnCollectionIds = this.rulesApplyOnCollection ? Object.values(this.rulesApplyOnCollection) : [];
    let rulesApplyOnCollectionIncludesProduct = [];
    let displayRule;
    let listDisplayRule = [];
    rulesApplyOnCollectionIds.map((ruleData) => {
      if (ruleData.list_parents.some((parent) => this.collectionsOfProduct.includes(parent.split("/")[4]))) {
        rulesApplyOnCollectionIncludesProduct.push(ruleData);
      }
    });
    if (rulesApplyOnProductIds.length) {
      listDisplayRule = this.compareRule(rulesApplyOnProductIds);
    } else if (rulesApplyOnCollectionIncludesProduct.length) {
      listDisplayRule = this.compareRule(rulesApplyOnCollectionIncludesProduct);
    } else if (rulesApplyOnAllIds.length) {
      listDisplayRule = this.compareRule(rulesApplyOnAllIds);
    }
    displayRule = this.checkActiveRule(listDisplayRule);
    if (displayRule) {
      displayRule.show_free_gift_widget = displayRule.show_free_gift_widget === void 0 ? 1 : displayRule.show_free_gift_widget;
      displayRule.show_confetti_animation = displayRule.show_confetti_animation === void 0 ? 1 : displayRule.show_confetti_animation;
    }
    return displayRule;
  }
  checkActiveRule(listDisplayRule) {
    let displayRule;
    for (let i = 0; i < listDisplayRule.length; i++) {
      const rule = listDisplayRule[i];
      if (rule.start_at) {
        if (rule.end_at && new Date(rule.end_at) > /* @__PURE__ */ new Date()) {
          displayRule = rule;
          break;
        } else if (new Date(rule.start_at) <= /* @__PURE__ */ new Date()) {
          displayRule = rule;
          break;
        }
      } else {
        displayRule = rule;
        break;
      }
    }
    return displayRule;
  }
  compareRule(listRule) {
    let listDisplayRule = listRule.sort((a, b) => (/* @__PURE__ */ new Date(`${b.created_at}`)).getTime() - (/* @__PURE__ */ new Date(`${a.created_at}`)).getTime());
    return listDisplayRule;
  }
  openCartDrawAfterReload() {
    if (window.localStorage.getItem(this.ADDED_GIFT_LOCALSTORAGE_KEY) == "true" && this.displaySetting.cart_btn_selector) {
      window.localStorage.setItem(this.ADDED_GIFT_LOCALSTORAGE_KEY, false);
      if (document.querySelector(this.displaySetting.cart_btn_selector)) {
        setTimeout(() => {
          document.querySelector(this.displaySetting.cart_btn_selector).click();
        }, 500);
      }
    }
  }
  toggleFreeGiftModal(e) {
    if (e && !e.target.classList.contains("salepify-free-gift-modal-wrapper"))
      return;
    if (this.freeGiftModal.style.display === "block") {
      this.closeModal();
      if (this.isClaimed && !this.displayRule.auto_add_gift && this.giftSelected.size > 0) {
        window.location.reload();
      }
    } else {
      this.openModal();
    }
  }
  openModal() {
      this.freeGiftModal.style.display = "block";
      this.freeGiftModal.style.animation = "tlFreeGiftFadeIn 0.4s";
      if (this.displayRule.auto_add_gift) {
          this.freeGiftBoxText.style.display = "none";
      }
  }

  closeModal() {
      this.freeGiftModal.style.animation = "tlFreeGiftFadeOut 0.4s";
      if (this.displayRule.auto_add_gift) {
          this.freeGiftBoxText.style.display = "block";
      }
      setTimeout(() => {
          this.freeGiftModal.style.display = "none";
      }, 300)
  }
  async updateVariant() {
    try {
      await this.getRemainAmountToGetFreeGift();
      if (this.displayRule.show_free_gift_widget) {
        this.renderGiftBox();
      }
    } catch (error) {
      console.log("Error when updateVariant: ", error);
    }
  }
  getRemainAmountToGetFreeGift = async (data) => {
    let totalProductApplied = 0;
    let numberProductApplied = 0;
    let giftNumberInCart = 0;
    let remain = 0;
    let cartJsResponse = await fetch("/cart.js");
    let cartData = await cartJsResponse.json();
    if (this.displayRule.apply_to_product === this.APPLY_TO_PRODUCT.COLLECTION) {
      let listChildIds = this.displayRule.list_childs.map((a) => a.id.split("/")[4]);
      cartData.items.forEach((item2) => {
        let itemCollections = this.variantMapCollections.get(item2.id.toString());
        let isGift = false;
        item2.discounts.forEach((discount) => {
          if (item2.line_price == 0 && discount.title === this.displayRule.title && discount.amount == item2.original_line_price) {
            isGift = true;
          }
        });
        if (isGift) {
          if (this.displayRule.gift_type === this.GIFT_TYPE.SAME_BUY && itemCollections.some((collectionId) => this.displayRule.list_parents.includes(`gid://shopify/Collection/${collectionId}`)) || listChildIds.includes(item2.id.toString())) {
            giftNumberInCart += item2.quantity;
          }
        } else if (itemCollections && itemCollections.some((collectionId) => this.displayRule.list_parents.includes(`gid://shopify/Collection/${collectionId}`))) {
          numberProductApplied += item2.quantity;
          totalProductApplied += item2.presentment_price * item2.quantity * 100;
        }
      });
      if (data) {
        let itemCollections = this.variantMapCollections.get(data.id.toString());
        if (data.isGift) {
          giftNumberInCart += data.quantity;
        } else if (itemCollections && itemCollections.some((collectionId) => this.displayRule.list_parents.includes(`gid://shopify/Collection/${collectionId}`))) {
          totalProductApplied += data.quantity * data.presentment_price * 100;
          numberProductApplied += data.quantity;
        }
      }
    } else {
      let listChildIds = this.displayRule.list_childs.map((a) => a.id.split("/")[4]);
      cartData.items.forEach((item2) => {
        let isGift = false;
        item2.discounts.forEach((discount) => {
          if (item2.line_price == 0 && discount.title === this.displayRule.title && discount.amount == item2.original_line_price) {
            isGift = true;
          }
        });
        if (isGift) {
          if (listChildIds.includes(item2.id.toString())) {
            giftNumberInCart += item2.quantity;
          }
        } else if (this.displayRule.list_parents.includes(item2.id.toString())) {
          numberProductApplied += item2.quantity;
          totalProductApplied += item2.presentment_price * item2.quantity * 100;
        }
      });
      if (data) {
        if (data.isGift) {
          if (listChildIds.includes(item.id.toString())) {
            giftNumberInCart += data.quantity;
          }
        } else if (this.displayRule.list_parents.includes(data.id.toString())) {
          numberProductApplied += data.quantity;
          totalProductApplied += data.presentment_price * data.quantity * 100;
        }
      }
    }
    let canClaimCount = 0;
    if (this.displayRule.apply_condition_type === this.APPLY_CONDITION_TYPE.AMOUNT) {
      canClaimCount = Math.floor(totalProductApplied / (this.displayRule.apply_condition_value * 100 * this.currencyRate));
    } else {
      canClaimCount = Math.floor(numberProductApplied / this.displayRule.apply_condition_value);
    }
    let appliedCount = Math.floor(giftNumberInCart / this.displayRule.gift_qty);

    this.isConditionMet = appliedCount >= 1 ? true : false;
    
    let targetClaimCount = 0;
    if (this.displayRule.maximum_per_order) {
      if (appliedCount >= this.displayRule.maximum_per_order) {
        appliedCount = this.displayRule.maximum_per_order;
        targetClaimCount = this.displayRule.maximum_per_order;
        if (appliedCount >= canClaimCount) {
          this.claimedCount = canClaimCount;
          this.canClaimCount = appliedCount;
        } else {
          this.claimedCount = appliedCount;
          this.canClaimCount = appliedCount;
        }
      } else {
        if (canClaimCount >= this.displayRule.maximum_per_order) {
          canClaimCount = this.displayRule.maximum_per_order;
          targetClaimCount = canClaimCount;
          this.claimedCount = appliedCount;
          this.canClaimCount = canClaimCount;
        } else {
          if (appliedCount > canClaimCount) {
            targetClaimCount = appliedCount;
            this.claimedCount = appliedCount;
            this.canClaimCount = appliedCount;
          } else if (appliedCount < canClaimCount) {
            targetClaimCount = canClaimCount;
            this.claimedCount = appliedCount;
            this.canClaimCount = canClaimCount;
          } else {
            targetClaimCount = canClaimCount + 1;
            this.claimedCount = canClaimCount;
            this.canClaimCount = canClaimCount;
          }
        }
      }
    } else {
      if (appliedCount > canClaimCount) {
        targetClaimCount = appliedCount;
        this.claimedCount = appliedCount;
        this.canClaimCount = appliedCount;
      } else if (appliedCount < canClaimCount) {
        targetClaimCount = canClaimCount;
        this.claimedCount = appliedCount;
        this.canClaimCount = canClaimCount;
      } else {
        targetClaimCount = canClaimCount + 1;
        this.claimedCount = canClaimCount;
        this.canClaimCount = canClaimCount;
      }
    }
    if (this.displayRule.apply_condition_type === this.APPLY_CONDITION_TYPE.AMOUNT) {
      remain = this.displayRule.apply_condition_value * 100 * this.currencyRate * targetClaimCount - totalProductApplied;
    } else {
      remain = this.displayRule.apply_condition_value * targetClaimCount - numberProductApplied;
    }
    if (targetClaimCount === this.claimedCount) {
      this.isClaimed = true;
    } else {
      this.isClaimed = false;
    }
    this.giftNumber = targetClaimCount * this.displayRule.gift_qty;
    if (this.displayRule.auto_add_gift) {
      this.residualGift = 0;
    } else {
      this.residualGift = this.giftNumber - giftNumberInCart;
      Array.from(this.giftSelected).map(([giftId, quantity]) => {
        this.residualGift -= quantity;
      });
    }
    this.remain = remain > 0 ? remain : 0;
  };
  increaseGiftQuantity(giftId, price) {
    if (this.residualGift > 0) {
      const giftInput = document.getElementById(`salepify-free-gift-input-${giftId}`);
      let value = parseInt(giftInput.value, 10);
      value = isNaN(value) ? 1 : value;
      value++;
      giftInput.value = value;
      this.giftSelected.set(giftId, value);
      this.residualGift--;
      document.getElementById(`salepify-free-gift-price-${giftId}`).innerText = this.formatMoney(price * value);
    }
    this.renderAvailableGift();
  }
  decreaseGiftQuantity(giftId, price) {
    const giftInput = document.getElementById(`salepify-free-gift-input-${giftId}`);
    let value = parseInt(giftInput.value, 10);
    value = isNaN(value) ? 1 : value;
    value--;
    value < 1 ? value = 1 : this.residualGift++;
    giftInput.value = value;
    this.giftSelected.set(giftId, value);
    document.getElementById(`salepify-free-gift-price-${giftId}`).innerText = this.formatMoney(price * value);
    this.renderAvailableGift();
  }
  changeGiftQuantity(evt, giftId, price) {
    const valueBeforeChange = this.giftSelected.get(giftId);
    let value = parseInt(evt.value, 10);
    value = isNaN(value) ? 1 : value;
    value < 1 ? value = 1 : "";
    const changeValue = value - valueBeforeChange;
    if (changeValue <= this.residualGift) {
      evt.value = value;
      this.giftSelected.set(giftId, value);
      this.residualGift -= changeValue;
      document.getElementById(`salepify-free-gift-price-${giftId}`).innerText = this.formatMoney(price * value);
    } else {
      evt.value = this.residualGift + valueBeforeChange;
      document.getElementById(`salepify-free-gift-price-${giftId}`).innerText = this.formatMoney(price * (this.residualGift + valueBeforeChange));
      this.residualGift = 0;
    }
    this.renderAvailableGift();
  }
  showError(message) {
    this.errorBlock.style = "display: flex;";
    this.errorBlock.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="0 0 512 512">
                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
            </svg>
            <span id="salepify-free-gift-error__message">${message}</span>
        `;
    this.setErrTimeOut(3e3);
  }
  setErrTimeOut(times) {
    if (this.errorSetTimout) {
      clearTimeout(this.errorSetTimout);
    }
    this.errorSetTimout = setTimeout(() => {
      this.errorBlock.style = "display: none;";
      this.errorBlock.innerHTML = "";
      this.errorSetTimout = null;
    }, times);
  }
  changeGiftChecked(evt, giftId) {
    if (evt.checked) {
      if (this.residualGift > 0) {
        this.giftSelected.set(giftId, 1);
        this.residualGift--;
        document.getElementById(`salepify-free-gift-input-number-container-${giftId}`).style = "display: flex";
      } else {
        evt.checked = false;
      }
    } else {
      this.residualGift += this.giftSelected.get(giftId);
      this.giftSelected.delete(giftId);
      document.getElementById(`salepify-free-gift-input-${giftId}`).value = 1;
      document.getElementById(`salepify-free-gift-input-number-container-${giftId}`).style = "display: none";
    }
    this.renderAvailableGift();
  }
  renderAvailableGift() {
    if (this.residualGift > 0) {
      this.giftDescription.innerHTML = this.displaySetting.text_display.choose_gift_message.replace("{{gift_remain}}", `<strong>${this.residualGift}</strong>`);
    } else {
      this.giftDescription.innerHTML = this.displaySetting.text_display.choose_enough_gift_message;
    }
  }
  getGiftHtml(variant, product, additionClass, quantity = 1) {
    return `
            <div class="salepify-free-gift-gift ${additionClass}">
                <div class="salepify-free-gift-checkbox-wrapper">
                    <input 
                        class="inp-cbx" 
                        id="salepify-free-gift-checkbox-${variant.id}" 
                        type="checkbox"
                        onchange="window.tlFreeGift.changeGiftChecked(this, ${variant.id})"/>
                    <label class="cbx" for="salepify-free-gift-checkbox-${variant.id}">
                        <span>
                            <svg width="12px" height="10px">
                                <use xlink:href="#check-4"></use>
                            </svg>
                        </span>
                    </label>
                    <svg class="inline-svg" viewbox="0 0 12 10">
                        <symbol id="check-4">
                            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                        </symbol>
                    </svg>
                </div>
                <div class="salepify-free-gift-gift__info"> 
                    <a href="/products/${product.handle}?variant=${variant.id}" target="_blank">
                        <img src="${variant.featured_image && variant.featured_image.src ? variant.featured_image.src : product.images[0]}" alt="Variant Image"/> 
                    </a>
                    <div> 
                        <a href="/products/${product.handle}?variant=${variant.id}" target="_blank" class="salepify-free-gift-gift__title">  
                            ${product.title} ${variant.title === "Default Title" ? "" : "- " + variant.title}
                        </a>
                        <div class="salepify-free-gift-gift__price">  
                            <span class="salepify-free-gift-free-lable">${this.displaySetting.text_display.free_text_content}</span>
                            <span class="salepify-free-gift-compare-price" id="salepify-free-gift-price-${variant.id}">${this.formatMoney(variant.price * quantity)}</span>
                        </div>

                        <div class="salepify-free-gift-badge-qty">
                            x${quantity}
                        </div>

                        <div class="salepify-free-gift-input-number-container" id="salepify-free-gift-input-number-container-${variant.id}">
                            <button type="button" onclick="window.tlFreeGift.decreaseGiftQuantity(${variant.id}, ${variant.price})" class="salepify-free-gift-input-number-container__decrease">-</button>
                            <input 
                                type="number" 
                                class="salepify-free-gift-input-number" 
                                id="salepify-free-gift-input-${variant.id}"  
                                min="1" 
                                step="1" 
                                value="1" 
                                onchange="window.tlFreeGift.changeGiftQuantity(this, ${variant.id},  ${variant.price})"/>
                            <button type="button" onclick="window.tlFreeGift.increaseGiftQuantity(${variant.id},  ${variant.price})" class="salepify-free-gift-input-number-container__increase">+</button>
                        </div>
                    </div>
                </div>
            </div>`;
  }
  async renderGifts() {
    let uniqueGiftHandle = /* @__PURE__ */ new Set();
    let listVariantGift = [];
    this.displayRule.list_childs.map((child) => {
      uniqueGiftHandle.add(child.handle);
      listVariantGift.push(child.id);
    });
    uniqueGiftHandle = Array.from(uniqueGiftHandle);
    const productGiftDataReq = this.displayRule.gift_type === this.GIFT_TYPE.SAME_BUY && this.displayRule.apply_to_product === this.APPLY_TO_PRODUCT.COLLECTION ? [] : await Promise.all(uniqueGiftHandle.map((handle) => fetch(window.Shopify.routes.root + `products/${handle}.js`)));
    const productGiftDataRes = await Promise.all(productGiftDataReq.map((req) => req.json()));
    let listGiftHtml = "";
    if (this.displayRule.auto_add_gift) {
      if (this.displayRule.auto_add_type === this.AUTO_ADD_TYPE.SELECT_TO_ADD) {
        listVariantGift = Object.keys(this.displayRule.gift_auto_add_map_qty);
        productGiftDataRes.map((product) => {
          product.variants.map((variant) => {
            const globalId = "gid://shopify/ProductVariant/" + variant.id;
            if (listVariantGift.includes(globalId)) {
              const addQty = this.displayRule.gift_auto_add_map_qty[globalId];
              listGiftHtml += this.getGiftHtml(variant, product, "salepify-free-gift-gift--with-qty-badge", addQty);
              this.giftSelected.set(variant.id, addQty);
            }
          });
        });
      } else {
        let hasAvailableGift = false;
        for (let i = 0; i < productGiftDataRes.length; i++) {
          const product = productGiftDataRes[i];
          if (!hasAvailableGift) {
            for (let j = 0; j < product.variants.length; j++) {
              const variant = product.variants[j];
              if (listVariantGift.includes("gid://shopify/ProductVariant/" + variant.id) && variant.available) {
                this.giftSelected.set(variant.id, this.displayRule.gift_qty);
                listGiftHtml += this.getGiftHtml(variant, product, "salepify-free-gift-gift--with-qty-badge", this.displayRule.gift_qty);
                hasAvailableGift = true;
                break;
              }
            }
          } else {
            break;
          }
        }
      }
      this.residualGift = 0;
    } else {
      if (this.displayRule.gift_type === this.GIFT_TYPE.SAME_BUY) {
        if (this.displayRule.apply_to_product === this.APPLY_TO_PRODUCT.COLLECTION) {
          this.displayRule.list_childs.map((collection) => {
            listGiftHtml += `<a href="/collections/${collection.handle}" target="_blank">${collection.title}</a>`;
          });
        } else {
          productGiftDataRes.map((product) => {
            product.variants.map((variant) => {
              if (listVariantGift.includes("gid://shopify/ProductVariant/" + variant.id)) {
                listGiftHtml += this.getGiftHtml(variant, product, "");
              }
            });
          });
        }
      } else {
        productGiftDataRes.map((product) => {
          product.variants.map((variant) => {
            if (listVariantGift.includes("gid://shopify/ProductVariant/" + variant.id)) {
              listGiftHtml += this.getGiftHtml(variant, product, "salepify-free-gift-gift--with-qty-selector");
            }
          });
        });
      }
    }
    this.freeGiftList.innerHTML = listGiftHtml;
  }
  async handleClaimGifts() {
    let claimCount = 1;
    if (this.displayRule.auto_add_gift) {
      claimCount = this.canClaimCount - this.claimedCount;
    }
    let formData = {
      "items": Array.from(this.giftSelected).map(([giftId, quantity]) => {
        const qty = quantity * claimCount;
        return {
          "id": giftId,
          "quantity": qty
        };
      })
    };
    if (this.giftSelected.size > 0 && (this.residualGift <= 0 || this.displayRule.auto_add_gift)) {
      this.claimButton.disabled = true;
      this.claimButton.innerHTML = "<div class='salepify-free-gift-loader'></div>";
      let addToCartRes = await fetch(window.Shopify.routes.root + "cart/add.js?app=salepify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
      let addToCartData = await addToCartRes.json();
      if (addToCartData.items) {
        this.claimButton.innerHTML = this.displaySetting.text_display.claimed_button;
        this.claimButton.style.boxShadow = "none";
        this.claimButton.style.background = "grey";
        this.claimButton.style.cursor = "no-drop";
        this.freeGiftBoxText.innerText = this.displaySetting.text_display.gift_icon_text_claimed;
        if (!this.displayRule.auto_add_gift) {
          window.location.reload();
        } else {
          if (this.displayRule.maximum_per_order && this.displayRule.maximum_per_order <= this.claimedCount) {
            this.isClaimed = true;
          } else {
            await this.getRemainAmountToGetFreeGift();
          }
          this.renderGiftBox();
        }
      } else {
        this.claimButton.innerHTML = this.replaceVariables(this.displaySetting.text_display.claim_button);
        this.showError(this.displaySetting.text_display.error_message);
      }
      this.claimButton.disabled = false;
    } else {
      this.showError(this.displaySetting.text_display.warning_message);
    }
  }
  renderGiftBox() {
    if (this.displayRule.display_type === "block" || !this.displayRule.show_free_gift_widget)
      return;
    this.freeGiftBoxIcon.style.display = this.displaySetting.gift_icon_style.is_icon_displayed ? "block" : "none";
    this.freeGiftBox.style.display = "flex";
    this.freeGiftBox.style.backgroundImage = this.displaySetting.gift_icon_style.is_icon_displayed ? "none" : `url(${this.displaySetting.gift_icon_style.free_gift_image.url})`;
    let listCheckBoxGift = [];
    let totalGiftHtml = this.displaySetting.text_display.optional_message;
    if (this.displayRule.auto_add_gift) {
      totalGiftHtml = this.displaySetting.text_display.optional_message_auto_add;
      totalGiftHtml = totalGiftHtml.replace("{{gift_number}}", `<strong>${this.giftNumber}</strong>`);
    } else {
      listCheckBoxGift = document.querySelectorAll("input[id^=salepify-free-gift-checkbox-]");
      totalGiftHtml = totalGiftHtml.replace("{{gift_number}}", `<strong>${this.giftNumber}</strong>`);
    }
    this.totalGift.innerHTML = `${totalGiftHtml}`;
    const textDisplaySetting = this.displaySetting.text_display;
    if (this.remain <= 0) {
      this.headerDescription.innerHTML = this.replaceVariables(textDisplaySetting.achieve_title);
      if (!this.displayRule.auto_add_gift) {
          this.freeGiftBadge.style.display = "flex";
          this.freeGiftBoxText.innerText = this.replaceVariables(textDisplaySetting.gift_icon_text);
          this.freeGiftBoxText.style.display = "block";
      }
      if (this.isClaimed) {
        this.giftDescription.innerHTML = ``;
        this.totalGift.innerHTML = this.displaySetting.text_display.claim_all_gift_message;
        this.claimButton.innerText = this.displaySetting.text_display.claimed_button;
        this.claimButton.disabled = true;
        this.claimButton.style.boxShadow = "none";
        this.claimButton.style.background = "grey";
        this.claimButton.style.cursor = "no-drop";
        this.freeGiftBoxText.innerText = this.displaySetting.text_display.gift_icon_text_claimed;
        listCheckBoxGift.forEach((ele) => {
          ele.parentNode.style.display = "none";
        });
      } else {
        if (this.displayRule.gift_type !== this.GIFT_TYPE.SAME_BUY) {
          listCheckBoxGift.forEach((ele) => {
            ele.disabled = false;
            ele.parentNode.style.display = "block";
          });
          this.giftDescription.innerHTML = this.displaySetting.text_display.choose_gift_message.replace("{{gift_remain}}", `<strong>${this.residualGift}</strong>`);
          this.claimButton.innerText = this.replaceVariables(textDisplaySetting.claim_button);
          this.claimButton.disabled = false;
          this.claimButton.style.boxShadow = "";
          this.claimButton.style.background = "";
          this.claimButton.style.cursor = "";
          if (!this.displayRule.auto_add_gift) {
              this.freeGiftBoxText.innerText = this.replaceVariables(textDisplaySetting.gift_icon_text);
          } else {
              this.freeGiftBoxText.display = "none";
          }
        }
        if (!this.isShowedFirework) {
          const firework = new TLFreeGiftFireworks();
          if (this.displayRule.show_confetti_animation) {
            firework.partyTime();
          }
          if (!this.displayRule.auto_add_gift) {
            this.openModal();
          }
          this.isShowedFirework = true;
        }
      }
      if (!this.displayRule.auto_add_gift) {
        this.claimButton.style.display = "flex";
      }
    } else {
      listCheckBoxGift.forEach((ele) => {
        const giftId = ele.id.replace("salepify-free-gift-checkbox-", "");
        document.getElementById(`salepify-free-gift-input-${giftId}`).value = 1;
        document.getElementById(`salepify-free-gift-input-number-container-${giftId}`).style = "display: none";
        ele.disabled = true;
        ele.checked = false;
        this.giftSelected = /* @__PURE__ */ new Map();
      });
      this.claimButton.style.display = "none";
      this.freeGiftBadge.style.display = "none";
      this.freeGiftBoxText.style.display = "none";
      this.isShowedFirework = false;
      if (this.displayRule.apply_condition_type === this.APPLY_CONDITION_TYPE.AMOUNT) {
        this.headerDescription.innerHTML = this.replaceVariables(textDisplaySetting.remain_title);
        let descText = this.replaceVariables(this.displaySetting.text_display.upsell_message_amount);
        descText = descText.replace("{{product}}", `<strong>${tlFreeGiftCurrentProductTitle}<strong>`);
        descText = descText.replace("{{remain}}", `<strong>${this.formatMoney(this.displayRule.apply_condition_value * 100)}</strong>`);
        this.giftDescription.innerHTML = descText;
      } else {
        this.headerDescription.innerHTML = this.replaceVariables(textDisplaySetting.remain_title);
        let descText = this.replaceVariables(this.displaySetting.text_display.upsell_message_qty);
        descText = descText.replace("{{product}}", `<strong>${tlFreeGiftCurrentProductTitle}<strong>`);
        descText = descText.replace("{{remain}}", `<strong>${this.displayRule.apply_condition_value}</strong>`);
        this.giftDescription.innerHTML = descText;
      }
    }
    if (this.displayRule.gift_type === this.GIFT_TYPE.SAME_BUY)
      this.claimButton.style = "display: none !important";

    if (this.displayRule.auto_add_gift && this.isConditionMet) {
        this.freeGiftBoxText.innerText = textDisplaySetting.gift_icon_text_claimed;
        this.freeGiftBoxText.style.display = "block";
    }
  }
}
const tlFreeGiftOverride = () => {
  if (!window || !window.Shopify)
    return;
  const CartEvents = {
    add: "TLFREEGIFT:add",
    update: "TLFREEGIFT:update",
    change: "TLFREEGIFT:change",
    clear: "TLFREEGIFT:clear",
    mutate: "TLFREEGIFT:mutate"
  };
  const ShopifyCartURLs = [
    "/cart/add",
    "/cart/update",
    "/cart/change",
    "/cart/clear",
    "/cart/add.js",
    "/cart/update.js",
    "/cart/change.js",
    "/cart/clear.js",
    "/cart/add.js?upcart=1&opens_cart=maybe"
  ];
  function isShopifyCartURL(url) {
    if (url instanceof URL)
      url = url.href;
    if (typeof url == "object" && url.url)
      url = url.url;
    if (!url || url.includes("app=salepify"))
      return false;
    try {
      let path = url.split("/").pop();
      path = path.split("?").shift();
      return ShopifyCartURLs.includes(`/cart/${path}`);
    } catch (e) {
      console.log("Not a normal URL: ", e);
      return false;
    }
  }
  function updateType(url) {
    if (!url || url.includes("app=salepify"))
      return false;
    if (url.includes("cart/add")) {
      return "add";
    } else if (url.includes("cart/update")) {
      return "update";
    } else if (url.includes("cart/change")) {
      return "change";
    } else if (url.includes("cart/clear")) {
      return "clear";
    } else
      return false;
  }
  function dispatchEvent(url, detail) {
    if (typeof detail === "string") {
      try {
        detail = JSON.parse(detail);
      } catch (e) {
        console.log("Error: ", e);
      }
    }
    const type = updateType(url);
    switch (type) {
      case "add":
        window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
        break;
      case "update":
        window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
        break;
      case "clear":
        window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
        break;
      case "change":
        window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
        break;
    }
  }
  function XHROverride() {
    if (!window.XMLHttpRequest)
      return;
    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function() {
      const url = arguments[1];
      if (isShopifyCartURL(url)) {
        this.addEventListener("load", async function() {
          if (window.tlFreeGift.isJson(this.response)) {
            const res = JSON.parse(this.response);
            if (res.id || res.items_added.length) {
              await window.tlFreeGift.getRemainAmountToGetFreeGift();
              if (window.tlFreeGift.displayRule.show_free_gift_widget) {
                window.tlFreeGift.renderGiftBox();
              }
            }
            if (window.tlFreeGift.displayRule.auto_add_gift && window.tlFreeGift.claimedCount < window.tlFreeGift.canClaimCount) {
              await window.tlFreeGift.handleClaimGifts();
              window.localStorage.setItem(window.tlFreeGift.ADDED_GIFT_LOCALSTORAGE_KEY, true);
              window.location.reload();
            }
          } else {
            dispatchEvent(url, this.response);
          }
        });
        return originalOpen.apply(this, arguments);
      } else {
        return originalOpen.apply(this, arguments);
      }
    };
  }
  function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== "function")
      return;
    const originalFetch = window.fetch;
    window.fetch = async function() {
      const [resource, config] = [...arguments];
      if (isShopifyCartURL(resource)) {
        if (window.tlFreeGift.displayRule && !window.tlFreeGift.isClaimed && config && config.body) {
          if (resource.includes("add")) {
            if (config.body instanceof FormData && config.body.getAll("id")) {
              const variantId = String(config.body.getAll("id"));
              let qty = Number(config.body.getAll("quantity"));
              qty = qty ? qty : 1;
              let presentmentPrice = tlFreeGiftVariantIdMapData.get(variantId).price / 100;
              let data = {
                id: variantId,
                quantity: qty,
                presentment_price: presentmentPrice
              };
              await window.tlFreeGift.getRemainAmountToGetFreeGift(data);
              if (window.tlFreeGift.displayRule.show_free_gift_widget) {
                window.tlFreeGift.renderGiftBox();
              }
              if (window.tlFreeGift.displayRule.auto_add_gift && window.tlFreeGift.claimedCount < window.tlFreeGift.canClaimCount) {
                await window.tlFreeGift.handleClaimGifts();
              }
            } else {
              let variantId = null;
              let qty = 1;
              const allRequestBody = config.body.split("&");
              if (allRequestBody.length) {
                allRequestBody.map((param) => {
                  if (param) {
                    const paramArray = param.split("=");
                    if (paramArray.length > 1) {
                      if (paramArray[0] === "id") {
                        variantId = paramArray[1];
                      } else if (paramArray[0] === "quantity") {
                        qty = paramArray[1] ? Number(paramArray[1]) : 1;
                      }
                    } else if (window.tlFreeGift.isJson(param)) {
                      const paramObj = JSON.parse(param);
                      if (paramObj.id) {
                        variantId = paramObj.id;
                        qty = paramObj.quantity ? Number(paramObj.quantity) : 1;
                      } else if (paramObj.items) {
                        for (let i = 0; i < paramObj.items.length; i++) {
                          const item2 = paramObj.items[i];
                          let itemId = String(item2.id);
                          if (tlFreeGiftVariantIdOfCurrentProduct.includes(itemId)) {
                            variantId = itemId;
                            qty = item2.quantity ? Number(item2.quantity) : 1;
                            break;
                          }
                        }
                      }
                    }
                  }
                });
              }
              if (variantId) {
                let presentmentPrice = tlFreeGiftVariantIdMapData.get(variantId)?.price ? tlFreeGiftVariantIdMapData.get(variantId).price / 100 : 0;
                let data = {
                  id: variantId,
                  quantity: qty,
                  presentment_price: presentmentPrice
                };
                await window.tlFreeGift.getRemainAmountToGetFreeGift(data);
                if (window.tlFreeGift.displayRule.show_free_gift_widget) {
                  window.tlFreeGift.renderGiftBox();
                }
                if (window.tlFreeGift.displayRule.auto_add_gift && window.tlFreeGift.claimedCount < window.tlFreeGift.canClaimCount) {
                  await window.tlFreeGift.handleClaimGifts();
                }
              }
            }
          } else if (window.tlFreeGift.displayRule.auto_add_gift) {
            const cartDataReq = await originalFetch("/cart.js", {
              method: "GET",
              headers: {
                "Content-Type": "application/json"
              }
            });
            const cartDataRes = await cartDataReq.json();
            let items = JSON.parse(JSON.stringify(cartDataRes.items));
            let isGift = false;
            if (items.length) {
              let lineChangeIndex = 0;
              const bodyArgument = JSON.parse(config.body);
              if (bodyArgument.line) {
                lineChangeIndex = Number(bodyArgument.line) - 1;
              } else {
                items.map((item2, index) => {
                  if (item2.key === bodyArgument.id) {
                    lineChangeIndex = index;
                  }
                });
              }
              const itemChangeData = items[lineChangeIndex];
              const newLineQty = Number(bodyArgument.quantity);
              const variantChangeId = itemChangeData.id;
              let diffQty = 0;
              let presentmentPrice = 0;
              let discountTitles = itemChangeData.discounts.map((a) => a.title);
              if (itemChangeData.line_price == 0 && discountTitles.includes(window.tlFreeGift.displayRule.title)) {
                isGift = true;
              }
              if (newLineQty > 0) {
                diffQty = newLineQty - itemChangeData.quantity;
                presentmentPrice = itemChangeData.presentment_price;
                itemChangeData.quantity = newLineQty;
              } else {
                diffQty = -itemChangeData.quantity;
                presentmentPrice = itemChangeData.presentment_price;
                items.splice(lineChangeIndex, 1);
              }
              let data = {
                isGift,
                id: variantChangeId,
                quantity: diffQty,
                presentment_price: presentmentPrice
              };
              await window.tlFreeGift.getRemainAmountToGetFreeGift(data);
              if (window.tlFreeGift.displayRule.show_free_gift_widget) {
                window.tlFreeGift.renderGiftBox();
              }
              if (window.tlFreeGift.claimedCount < window.tlFreeGift.canClaimCount) {
                await window.tlFreeGift.handleClaimGifts();
                const cartDataReq2 = await originalFetch("/cart.js", {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json"
                  }
                });
                const cartDataRes2 = await cartDataReq2.json();
                const dataUpdate = {
                  line: String(lineChangeIndex + 1),
                  quantity: String(newLineQty)
                };
                cartDataRes2.items.map((item2, index) => {
                  if (item2.id == variantChangeId) {
                    dataUpdate.line = String(index + 1);
                    dataUpdate.quantity = String(item2.quantity + diffQty);
                  }
                });
                arguments[1].body = JSON.stringify({
                  ...bodyArgument,
                  ...dataUpdate
                });
              }
            }
          }
        }
        const response = originalFetch.apply(this, arguments);
        response.then((res) => {
          res.clone().json().then((data) => dispatchEvent(res.url, data));
        });
        return response;
      } else {
        return originalFetch(...arguments);
      }
    };
  }
  if (window.tlFreeGift.displayRule && window.tlFreeGift.template === "product" && window.tlFreeGift.displayRule.display_type !== "block") {
    window.addEventListener("TLFREEGIFT:add", (event) => {
      window.tlFreeGift.updateVariant();
    });
    window.addEventListener("TLFREEGIFT:change", (event) => {
      window.tlFreeGift.updateVariant();
    });
    fetchOverride();
    XHROverride();
  }
};
!function(t, e) {
  !function t2(e2, n, a, i) {
    var o = !!(e2.Worker && e2.Blob && e2.Promise && e2.OffscreenCanvas && e2.OffscreenCanvasRenderingContext2D && e2.HTMLCanvasElement && e2.HTMLCanvasElement.prototype.transferControlToOffscreen && e2.URL && e2.URL.createObjectURL);
    function r() {
    }
    function l(t3) {
      var a2 = n.exports.Promise, i2 = void 0 !== a2 ? a2 : e2.Promise;
      return "function" == typeof i2 ? new i2(t3) : (t3(r, r), null);
    }
    var c, s, u, d, f, h, g, m, b = (u = Math.floor(1e3 / 60), d = {}, f = 0, "function" == typeof requestAnimationFrame && "function" == typeof cancelAnimationFrame ? (c = function(t3) {
      var e3 = Math.random();
      return d[e3] = requestAnimationFrame(function n2(a2) {
        f === a2 || f + u - 1 < a2 ? (f = a2, delete d[e3], t3()) : d[e3] = requestAnimationFrame(n2);
      }), e3;
    }, s = function(t3) {
      d[t3] && cancelAnimationFrame(d[t3]);
    }) : (c = function(t3) {
      return setTimeout(t3, u);
    }, s = function(t3) {
      return clearTimeout(t3);
    }), { frame: c, cancel: s }), v = (m = {}, function() {
      if (h)
        return h;
      if (!a && o) {
        var e3 = ["var CONFETTI, SIZE = {}, module = {};", "(" + t2.toString() + ")(this, module, true, SIZE);", "onmessage = function(msg) {", "  if (msg.data.options) {", "    CONFETTI(msg.data.options).then(function () {", "      if (msg.data.callback) {", "        postMessage({ callback: msg.data.callback });", "      }", "    });", "  } else if (msg.data.reset) {", "    CONFETTI.reset();", "  } else if (msg.data.resize) {", "    SIZE.width = msg.data.resize.width;", "    SIZE.height = msg.data.resize.height;", "  } else if (msg.data.canvas) {", "    SIZE.width = msg.data.canvas.width;", "    SIZE.height = msg.data.canvas.height;", "    CONFETTI = module.exports.create(msg.data.canvas);", "  }", "}"].join("\n");
        try {
          h = new Worker(URL.createObjectURL(new Blob([e3])));
        } catch (t3) {
          return void 0 !== typeof console && "function" == typeof console.warn && console.warn("🎊 Could not load worker", t3), null;
        }
        !function(t3) {
          function e4(e5, n2) {
            t3.postMessage({ options: e5 || {}, callback: n2 });
          }
          t3.init = function(e5) {
            var n2 = e5.transferControlToOffscreen();
            t3.postMessage({ canvas: n2 }, [n2]);
          }, t3.fire = function(n2, a2, i2) {
            if (g)
              return e4(n2, null), g;
            var o2 = Math.random().toString(36).slice(2);
            return g = l(function(a3) {
              function r2(e5) {
                e5.data.callback === o2 && (delete m[o2], t3.removeEventListener("message", r2), g = null, i2(), a3());
              }
              t3.addEventListener("message", r2), e4(n2, o2), m[o2] = r2.bind(null, { data: { callback: o2 } });
            });
          }, t3.reset = function() {
            for (var e5 in t3.postMessage({ reset: true }), m)
              m[e5](), delete m[e5];
          };
        }(h);
      }
      return h;
    }), y = {
      particleCount: 50,
      angle: 90,
      spread: 45,
      startVelocity: 45,
      decay: 0.9,
      gravity: 1,
      drift: 0,
      ticks: 200,
      x: 0.5,
      y: 0.5,
      shapes: ["square", "circle"],
      zIndex: 100,
      colors: ["#26ccff", "#a25afd", "#ff5e7e", "#88ff5a", "#fcff42", "#ffa62d", "#ff36ff"],
      disableForReducedMotion: false,
      scalar: 1
    };
    function p(t3, e3, n2) {
      return function(t4, e4) {
        return e4 ? e4(t4) : t4;
      }(t3 && null != t3[e3] ? t3[e3] : y[e3], n2);
    }
    function M(t3) {
      return t3 < 0 ? 0 : Math.floor(t3);
    }
    function w(t3) {
      return parseInt(t3, 16);
    }
    function x(t3) {
      return t3.map(C);
    }
    function C(t3) {
      var e3 = String(t3).replace(/[^0-9a-f]/gi, "");
      return e3.length < 6 && (e3 = e3[0] + e3[0] + e3[1] + e3[1] + e3[2] + e3[2]), {
        r: w(e3.substring(0, 2)),
        g: w(e3.substring(2, 4)),
        b: w(e3.substring(4, 6))
      };
    }
    function k(t3) {
      t3.width = document.documentElement.clientWidth, t3.height = document.documentElement.clientHeight;
    }
    function I(t3) {
      var e3 = t3.getBoundingClientRect();
      t3.width = e3.width, t3.height = e3.height;
    }
    function T(t3, e3, n2, o2, r2) {
      var c2, s2, u2 = e3.slice(), d2 = t3.getContext("2d"), f2 = l(function(e4) {
        function l2() {
          c2 = s2 = null, d2.clearRect(0, 0, o2.width, o2.height), r2(), e4();
        }
        c2 = b.frame(function e5() {
          !a || o2.width === i.width && o2.height === i.height || (o2.width = t3.width = i.width, o2.height = t3.height = i.height), o2.width || o2.height || (n2(t3), o2.width = t3.width, o2.height = t3.height), d2.clearRect(0, 0, o2.width, o2.height), (u2 = u2.filter(function(t4) {
            return function(t5, e6) {
              e6.x += Math.cos(e6.angle2D) * e6.velocity + e6.drift, e6.y += Math.sin(e6.angle2D) * e6.velocity + e6.gravity, e6.wobble += 0.1, e6.velocity *= e6.decay, e6.tiltAngle += 0.1, e6.tiltSin = Math.sin(e6.tiltAngle), e6.tiltCos = Math.cos(e6.tiltAngle), e6.random = Math.random() + 5, e6.wobbleX = e6.x + 10 * e6.scalar * Math.cos(e6.wobble), e6.wobbleY = e6.y + 10 * e6.scalar * Math.sin(e6.wobble);
              var n3 = e6.tick++ / e6.totalTicks, a2 = e6.x + e6.random * e6.tiltCos, i2 = e6.y + e6.random * e6.tiltSin, o3 = e6.wobbleX + e6.random * e6.tiltCos, r3 = e6.wobbleY + e6.random * e6.tiltSin;
              return t5.fillStyle = "rgba(" + e6.color.r + ", " + e6.color.g + ", " + e6.color.b + ", " + (1 - n3) + ")", t5.beginPath(), "circle" === e6.shape ? t5.ellipse ? t5.ellipse(e6.x, e6.y, Math.abs(o3 - a2) * e6.ovalScalar, Math.abs(r3 - i2) * e6.ovalScalar, Math.PI / 10 * e6.wobble, 0, 2 * Math.PI) : function(t6, e7, n4, a3, i3, o4, r4, l3, c3) {
                t6.save(), t6.translate(e7, n4), t6.rotate(o4), t6.scale(a3, i3), t6.arc(0, 0, 1, r4, l3, c3), t6.restore();
              }(t5, e6.x, e6.y, Math.abs(o3 - a2) * e6.ovalScalar, Math.abs(r3 - i2) * e6.ovalScalar, Math.PI / 10 * e6.wobble, 0, 2 * Math.PI) : (t5.moveTo(Math.floor(e6.x), Math.floor(e6.y)), t5.lineTo(Math.floor(e6.wobbleX), Math.floor(i2)), t5.lineTo(Math.floor(o3), Math.floor(r3)), t5.lineTo(Math.floor(a2), Math.floor(e6.wobbleY))), t5.closePath(), t5.fill(), e6.tick < e6.totalTicks;
            }(d2, t4);
          })).length ? c2 = b.frame(e5) : l2();
        }), s2 = l2;
      });
      return {
        addFettis: function(t4) {
          return u2 = u2.concat(t4), f2;
        },
        canvas: t3,
        promise: f2,
        reset: function() {
          c2 && b.cancel(c2), s2 && s2();
        }
      };
    }
    function E(t3, n2) {
      var a2, i2 = !t3, r2 = !!p(n2 || {}, "resize"), c2 = p(n2, "disableForReducedMotion", Boolean), s2 = o && !!p(n2 || {}, "useWorker") ? v() : null, u2 = i2 ? k : I, d2 = !(!t3 || !s2) && !!t3.__confetti_initialized, f2 = "function" == typeof matchMedia && matchMedia("(prefers-reduced-motion)").matches;
      function h2(e3, n3, i3) {
        for (var o2, r3, l2, c3, s3, d3 = p(e3, "particleCount", M), f3 = p(e3, "angle", Number), h3 = p(e3, "spread", Number), g3 = p(e3, "startVelocity", Number), m2 = p(e3, "decay", Number), b2 = p(e3, "gravity", Number), v2 = p(e3, "drift", Number), y2 = p(e3, "colors", x), w2 = p(e3, "ticks", Number), C2 = p(e3, "shapes"), k2 = p(e3, "scalar"), I2 = function(t4) {
          var e4 = p(t4, "origin", Object);
          return e4.x = p(e4, "x", Number), e4.y = p(e4, "y", Number), e4;
        }(e3), E2 = d3, S = [], F = t3.width * I2.x, N = t3.height * I2.y; E2--; )
          S.push((o2 = {
            x: F,
            y: N,
            angle: f3,
            spread: h3,
            startVelocity: g3,
            color: y2[E2 % y2.length],
            shape: C2[c3 = 0, s3 = C2.length, Math.floor(Math.random() * (s3 - c3)) + c3],
            ticks: w2,
            decay: m2,
            gravity: b2,
            drift: v2,
            scalar: k2
          }, r3 = void 0, l2 = void 0, r3 = o2.angle * (Math.PI / 180), l2 = o2.spread * (Math.PI / 180), {
            x: o2.x,
            y: o2.y,
            wobble: 10 * Math.random(),
            velocity: 0.5 * o2.startVelocity + Math.random() * o2.startVelocity,
            angle2D: -r3 + (0.5 * l2 - Math.random() * l2),
            tiltAngle: Math.random() * Math.PI,
            color: o2.color,
            shape: o2.shape,
            tick: 0,
            totalTicks: o2.ticks,
            decay: o2.decay,
            drift: o2.drift,
            random: Math.random() + 5,
            tiltSin: 0,
            tiltCos: 0,
            wobbleX: 0,
            wobbleY: 0,
            gravity: 3 * o2.gravity,
            ovalScalar: 0.6,
            scalar: o2.scalar
          }));
        return a2 ? a2.addFettis(S) : (a2 = T(t3, S, u2, n3, i3)).promise;
      }
      function g2(n3) {
        var o2 = c2 || p(n3, "disableForReducedMotion", Boolean), g3 = p(n3, "zIndex", Number);
        if (o2 && f2)
          return l(function(t4) {
            t4();
          });
        i2 && a2 ? t3 = a2.canvas : i2 && !t3 && (t3 = function(t4) {
          var e3 = document.createElement("canvas");
          return e3.style.position = "fixed", e3.style.top = "0px", e3.style.left = "0px", e3.style.pointerEvents = "none", e3.style.zIndex = t4, e3;
        }(g3), document.body.appendChild(t3)), r2 && !d2 && u2(t3);
        var m2 = { width: t3.width, height: t3.height };
        function b2() {
          if (s2) {
            var e3 = {
              getBoundingClientRect: function() {
                if (!i2)
                  return t3.getBoundingClientRect();
              }
            };
            return u2(e3), void s2.postMessage({ resize: { width: e3.width, height: e3.height } });
          }
          m2.width = m2.height = null;
        }
        function v2() {
          a2 = null, r2 && e2.removeEventListener("resize", b2), i2 && t3 && (document.body.removeChild(t3), t3 = null, d2 = false);
        }
        return s2 && !d2 && s2.init(t3), d2 = true, s2 && (t3.__confetti_initialized = true), r2 && e2.addEventListener("resize", b2, false), s2 ? s2.fire(n3, m2, v2) : h2(n3, m2, v2);
      }
      return g2.reset = function() {
        s2 && s2.reset(), a2 && a2.reset();
      }, g2;
    }
    n.exports = E(null, { useWorker: true, resize: true }), n.exports.create = E;
  }(function() {
    return void 0 !== t ? t : "undefined" != typeof self ? self : this || {};
  }(), e, false), t.confetti = e.exports;
}(window, {});
class TLFreeGiftFireworks {
  constructor() {
    this.isAnimating = false;
    this.bindedAnimate = this.animate.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this.partyTime);
  }
  partyTime() {
    const end = Date.now() + 2e3;
    if (this.isAnimating)
      return;
    this.animate(end);
  }
  animate(end) {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 }
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 }
    });
    if (Date.now() < end) {
      this.isAnimating = true;
      requestAnimationFrame(() => this.animate(end));
    } else {
      this.isAnimating = false;
    }
  }
}
window.customElements.define("tl-free-gift-fireworks", TLFreeGiftFireworks, { extends: "button" });
const tlFreeGiftConstructor = () => {
  window.tlFreeGift = window.tlFreeGift || new tlFreeGift(
    tlFreeGiftVariantMapCollections,
    tlFreeGiftTemplate,
    tlFreeGiftRulesApplyOnAll,
    tlFreeGiftRulesApplyOnCollection,
    tlFreeGiftRulesApplyOnProduct,
    tlFreeGiftCollectionsOfProduct,
    tlFreeGiftDisplaySetting
  );
};
if (typeof isEnableTLAdvancedFG == "undefined") {
  tlFreeGiftConstructor();
}